export function ComposeGameRiskInfoKey(oid, riskLabel, pfSubPfId) {
    return [oid, riskLabel, pfSubPfId].join(',')
}

export function ComposeRiskRuleKey(riskLabel, pfSubPfId) {
    return [riskLabel, pfSubPfId].join(',')
}
